import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateHomeTextImageSplit(section, img, number, textLines, hr, buttons) {
  
  // Individual tweens 
  // Image
  let imgTween = img ? gsap.to(img, {
    duration: 0.8,
    opacity: 1,
    ease: "power1.in",
  }) : null;

  // Number Group 
  let numberTween = number ? gsap.to(number, {
    duration: 0.4,
    x: 0,
    opacity: 1,
  }) : null;

  // Animated lines of text 
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated HR
  let hrTween = hr ? gsap.to(hr, {
    duration: 0.7,
    width: "100%",
    opacity: 1,
  }) : null;

  // Buttons 
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline 
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .add(imgTween)
    .addLabel("imgIn")
    .add(numberTween, "imgIn-=0.75")
    .add(textLinesTween, "imgIn-=0.75")
    .add(hrTween, "imgIn-=0.4")    
    .add(buttonsTween, "-=0.5");
    
}